import { render } from "./motion-text-display.vue?vue&type=template&id=16259129"
import script from "./motion-text-display.vue?vue&type=script&lang=js"
export * from "./motion-text-display.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__